// import React, { useState, useEffect, useRef } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import {
//   getSupportDetailsServ,
//   updateSupportDetailsServ,
// } from "../../../services/support.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";
// import JoditEditor from "jodit-react";
// import {useNavigate} from "react-router-dom"
// function UserPrivacyPolicy() {
//   const navigate = useNavigate()
//   const staticsArr = [
//     {
//       title: "User",
//       count: "Privacy Policy",
//       bgColor: "#6777EF",
//       path:"/user-privacy-policy"
//     },
//   ];
//   const editor = useRef(null);
//   const [content, setContent] = useState("");
//   const [_id, setId] = useState("");
//   const [btnLoader, setBtnLoader] = useState(false);
//   const contentRef = useRef(""); // ✅ Store content without causing re-renders

//   // Jodit Editor Config
//   const config = {
//     placeholder: "Start typing...",
//     height: "400px",
//   };

//   // Fetch Terms & Conditions
//   const getSupportDetailsFunc = async () => {
//     try {
//       const response = await getSupportDetailsServ();
//       if (response?.data?.data) {
//         setContent(response.data.data.userPrivacyPolicy || "");
//         contentRef.current = response.data.data.userPrivacyPolicy || "";
//         setId(response.data.data._id);
//       }
//     } catch (error) {
//       console.error("Error fetching terms and conditions:", error);
//       toast.error("Failed to fetch terms and conditions.");
//     }
//   };

//   useEffect(() => {
//     getSupportDetailsFunc();
//   }, []);

//   // Handle Update Request
//   const handleSupportUpdateDetails = async () => {
//     if (!contentRef.current.trim()) {
//       toast.warn("Content cannot be empty!");
//       return;
//     }

//     setBtnLoader(true);
//     try {
//       const response = await updateSupportDetailsServ({ _id, userPrivacyPolicy: contentRef.current });
//       if (response?.data?.statusCode === 200) {
//         toast.success(response.data.message);
//         getSupportDetailsFunc();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Internal Server Error");
//     }
//     setBtnLoader(false);
//   };
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Policy" selectedItem="Privacy Policy" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div onClick={()=>navigate(v?.path)} className={"topCard  py-4 px-3 rounded mb-3 " + (v?.title=="User" ? " shadow border ":" shadow-sm")}>
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/10349/10349031.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h5 className="text-secondary">{v?.count}</h5>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="main-content">
//             <section className="section">
//               <div className="d-flex">
//                 <h4
//                   className="p-2 text-light shadow rounded mb-4 mt-3"
//                   style={{ background: "#6777EF" }}
//                 >
//                  Privacy Policy
//                 </h4>
//               </div>

//               <JoditEditor
//                 ref={editor}
//                 config={config}
//                 value={content}
//                 onChange={(newContent) => {
//                   contentRef.current = newContent; // ✅ Update ref without re-rendering
//                 }}
//               />

//               {/* Update Button */}
//               <button
//                 className="btn btn-primary w-100 mt-3"
//                 onClick={handleSupportUpdateDetails}
//                 disabled={btnLoader}
//               >
//                 {btnLoader ? "Updating ..." : "Update"}
//               </button>
//             </section>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UserPrivacyPolicy;


import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import {
  getSupportDetailsServ,
  updateSupportDetailsServ,
} from "../../../services/support.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";

/* ─── Scoped Styles ───────────────────────────────────── */
const styles = `
  .pp-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* Stat Card */
  .pp-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
    margin-bottom: 22px;
  }

  .pp-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: 0.2s;
    cursor: pointer;
    max-width: 340px;
  }

  .pp-stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0,0,0,0.04);
  }

  .pp-stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .pp-stat-icon img {
    width: 26px;
    height: 26px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(15%) sepia(97%) saturate(7481%) hue-rotate(357deg) brightness(102%) contrast(117%);
  }

  .pp-stat-title {
    font-size: 14px;
    color: #999;
    margin-bottom: 3px;
  }

  .pp-stat-value {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
  }

  /* Editor Card */
  .pp-editor-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .pp-editor-header {
    padding: 18px 22px;
    border-bottom: 1px solid #f7f5f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }

  .pp-editor-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .pp-editor-sub {
    font-size: 13px;
    color: #aaa;
    margin-top: 3px;
  }

  .pp-editor-body {
    padding: 22px;
  }

  /* Jodit */
  .jodit-container {
    border-radius: 14px !important;
    overflow: hidden;
    border: 1px solid #f0eded !important;
  }

  .jodit-toolbar__box {
    border-bottom: 1px solid #f0eded !important;
    background: #fafafa !important;
  }

  /* Update Button */
  .pp-update-btn {
    height: 48px;
    border: none;
    border-radius: 12px;
    background: #a60808;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 0 24px;
    margin-top: 22px;
    transition: 0.2s;
    width: 100%;
  }

  .pp-update-btn:hover {
    background: #a93226;
  }

  .pp-update-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    .pp-page {
      padding: 18px;
    }

    .pp-editor-body {
      padding: 16px;
    }
  }
`;

function UserPrivacyPolicy() {
  const navigate = useNavigate();
  const editor = useRef(null);

  const [content, setContent] = useState("");
  const [_id, setId] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);

  const contentRef = useRef("");

  const config = {
    placeholder: "Start typing privacy policy content...",
    height: 500,
  };

  const staticsArr = [
    {
      title: "Policy",
      count: "Privacy Policy",
      path: "/user-privacy-policy",
      icon: "https://cdn-icons-png.flaticon.com/128/10349/10349031.png",
    },
  ];

  const getSupportDetailsFunc = async () => {
    try {
      const response = await getSupportDetailsServ();

      if (response?.data?.data) {
        setContent(response.data.data.userPrivacyPolicy || "");
        contentRef.current = response.data.data.userPrivacyPolicy || "";
        setId(response.data.data._id);
      }
    } catch (error) {
      toast.error("Failed to fetch privacy policy.");
    }
  };

  useEffect(() => {
    getSupportDetailsFunc();
  }, []);

  const handleSupportUpdateDetails = async () => {
    if (!contentRef.current.trim()) {
      toast.warn("Content cannot be empty!");
      return;
    }

    setBtnLoader(true);

    try {
      const response = await updateSupportDetailsServ({
        _id,
        userPrivacyPolicy: contentRef.current,
      });

      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message);
        getSupportDetailsFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Internal Server Error"
      );
    }

    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar selectedMenu="Policy" selectedItem="Privacy Policy" />

      <div className="mainContainer">
        <TopNav
          pageTitle="Privacy Policy"
          pagePath="Home / Policy / Privacy Policy"
        />

        <div className="pp-page">

          {/* ── Top Card ── */}
          <div className="pp-stat-grid">
            {staticsArr.map((v, i) => (
              <div
                key={i}
                className="pp-stat-card"
                onClick={() => navigate(v.path)}
              >
                <div className="pp-stat-icon">
                  <img src={v.icon} alt="icon" />
                </div>

                <div>
                  <div className="pp-stat-title">{v.title}</div>
                  <div className="pp-stat-value">{v.count}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Editor Section ── */}
          <div className="pp-editor-card">

            <div className="pp-editor-header">
              <div>
                <div className="pp-editor-title">
                  Manage Privacy Policy
                </div>

                <div className="pp-editor-sub">
                  Update and manage your platform privacy policy content
                </div>
              </div>
            </div>

            <div className="pp-editor-body">

              <JoditEditor
                ref={editor}
                config={config}
                value={content}
                onChange={(newContent) => {
                  contentRef.current = newContent;
                }}
              />

              <button
                className="pp-update-btn"
                onClick={handleSupportUpdateDetails}
                disabled={btnLoader}
              >
                {btnLoader ? "Updating..." : "Update Privacy Policy"}
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UserPrivacyPolicy;